@use "foundation/_responsive.scss";
@use "foundation/_mixins.scss";
@use "foundation/_colors.scss";

section.payment-success-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  /* ensure container will cover 100% area */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  @include responsive.tablet {
    flex-direction: column;
  }

  section {
    width: 50%;

    @include responsive.tablet {
      width: 100%;

      &.success-illustration {
        height: 60%;
      }

      &.payment-content {
        height: 40%;
      }
    }

    @include responsive.phone {
      &.success-illustration,
      &.payment-content {
        height: 50%;
      }
    }

    @include responsive.small-phone {
      &.success-illustration {
        height: 40%;
      }

      &.payment-content {
        height: 60%;
      }
    }

    &.success-illustration {
      /* background-image set in app/assets/stylesheets/application/controllers/_subscriptions.scss */
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &.payment-content {
      position: relative;

      padding: 0 40px;

      $paymentContentPadding: 20px;
      @include responsive.tablet {
        padding: 0 $paymentContentPadding !important;
      }

      .progress-bar {
        display: flex;
        flex-direction: row;
        justify-content: center;

        margin-top: mixins.em(64px);

        span {
          height: 16px;
          margin: 0 mixins.em(24px);

          @include responsive.tablet {
            margin: 0 mixins.em(16px);
          }

          &:before {
            content: '';
            display: inline-block;
            width: 8px;
            height: 8px;
            -moz-border-radius: 7.5px;
            -webkit-border-radius: 7.5px;
            border-radius: 7.5px;
            background-color: colors.$neutrals-grey;
          }

          &.active {
            &:before {
              width: 16px;
              height: 16px;
              margin-top: calc((16px - 8px)/2);
              background-color: colors.$neutrals-darker-grey;
            }
          }
        }

        &.show-on-tablet {
          display: none;

          @include responsive.tablet {
            display: flex;

            margin-top: mixins.em(32px);
          }
        }
      }

      h1 {
        margin-top: mixins.rem(128px);
        margin-bottom: mixins.rem(32px);

        @include responsive.tablet {
          margin-top: mixins.rem(24px);
          margin-bottom: mixins.rem(16px);
        }
      }

      p {
        font-weight: 600;
        font-size: 1.2em;

        @include responsive.phone {
          font-size: 1em;
        }
      }

      .action-buttons-container {
        button {
          margin-top: .5em;
          margin-bottom: .5em;
          max-width: 50%;
        }

        position: absolute;
        bottom: 0;

        margin-bottom: 56px;

        @include responsive.tablet {
          position: initial;
          flex-direction: row-reverse;
          justify-content: space-between;
          margin-bottom: initial;
        }

        &.one_action {
          button:last-child {
            display: none;
          }

          @include responsive.tablet {
            justify-content: center;
          }
        }
      }

      .tablet-container {
        @include responsive.tablet {
          position: absolute;
          /* hack: because of absolute to fix the container in the bottom, width 100% is not respecting the margin from container and leaking borders */
          width: calc(100% - (2*$paymentContentPadding));
          bottom: 2em;
        }
      }
    }
  }
}
